import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'flowbite-react';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import MyAuthContext from '../context/AuthContext';

import Loading from './Loading';
import ErrorWrapper from './ErrorWrapper';

import { style, capitalize } from './ModalSignUp';

const ModalProfileUpdate = ({isModalProfileUpdateOpen, setIsModalProfileUpdateOpen, setSuccessAlert}) => {
    const { updateUser, user, loading, } = useContext(MyAuthContext);

    const [error, setError] = useState({ "error": false, "message": "" });

    const schema = yup.object().shape({
        userName: yup.string().required("El nombre es requerido").matches(/^[a-zA-Z0-9À-ÿ \u00f1\u00d1]+$/, "El nombre no debe contener caracteres especiales").max(30, "Nombre demasiado largo").min(1).trim().transform((currentValue) => capitalize(currentValue)),
        userLastName: yup.string().required("El apellido es requerido").matches(/^[a-zA-Z0-9À-ÿ \u00f1\u00d1]+$/, "El apellido no debe contener caracteres especiales").max(30, "Apellido demasiado largo").min(1).trim().transform((currentValue) => capitalize(currentValue)),
        userPhone: yup.string().required("El numero de telefono es requerido ").min(8, "El numero de telefono es invalido").max(10, "El numero de telefono es demasiado largo"),
    })
    const { handleSubmit, control, register, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });
    const onSubmit = async (data) => {
        const res = await updateUser(data)
        if (res.error) {
            setError({ "error": true, "message": res.response })
            setTimeout(() => {
                setError({ "error": false, "message": "" })
            }, 5000);
        } else {
            setSuccessAlert("Perfil editado con exito")
            reset()
            setError({ "error": false, "message": "" })
            setIsModalProfileUpdateOpen(false)
            setTimeout(() => {
                setSuccessAlert(null)

            }, 3000);
        }
    }

    useEffect(() => {
        reset({
            userName: user.userName,
            userLastName: user.userLastName,
            userPhone: user.userPhone,
        })
    }, [user])

    const closeModal = () => {
        setIsModalProfileUpdateOpen(false)
        reset({
            userName: user.userName,
            userLastName: user.userLastName,
            userPhone: user.userPhone,
        })
    }
    return (
        <Modal show={isModalProfileUpdateOpen} style={{ height: "100%" }} position="center" onClose={reset} >
            <div className="flex flex-col items-center justify-center mx-auto">
                <div className='w-full bg-white rounded-lg shadow'>
                    <div className="p-6 space-y-4">
                        <div className="flex flex-row pt-3">
                            <h1 className="text-xl font-bold leading-tight tracking-tight  md:text-2xl">Editar Perfíl</h1>
                            <button className='absolute font-bold top-2 right-3' onClick={() => closeModal()}>x</button>
                        </div>
                        <p className='text-sm font-light text-gray-500'>En los campos señalados con * es obligatorio ingresar la informacion solicitada.</p>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="grid grid-cols-2 gap-6">
                                <div className="mb-6 ">
                                    <div className="relative z-0 w-full group">
                                        <input type="text" {...register("userName")} className={style.formInput} placeholder=" " />
                                        <label className={style.formLabel}>Nombres*</label>
                                    </div>
                                    <ErrorWrapper error={errors.userName?.message} />
                                </div>
                                <div className="relative z-0 mb-6 w-full group">
                                    <input type="text" {...register("userLastName")} className={style.formInput} placeholder=" " />
                                    <label className={style.formLabel}>Apellidos*</label>
                                    <ErrorWrapper error={errors.userLastName?.message} />
                                </div>
                            </div>

                            <div className="">
                                <div className="relative z-0 mb-6 w-full group">
                                    <Controller
                                        name="userPhone"
                                        control={control}
                                        defaultValue=""
                                        render={({ field: { value, onChange, ...field } }) => (
                                            <input type="tel" pattern="[0-9]{0,10}" className={style.formInput} placeholder=" "
                                                {...field}
                                                onChange={({ target: { value, validity } }) => {
                                                    const isValid = validity.valid
                                                    if (isValid) {
                                                        onChange(value);
                                                    }
                                                }
                                                }
                                                value={value}
                                            />
                                        )}
                                    />
                                    <label className={style.formLabel}>Telefono de Contacto*</label>
                                    <ErrorWrapper error={errors.userPhone?.message} />
                                </div>
                            </div>
                            <div className='text-center w-full mb-5'>
                                {error.error && <ErrorWrapper error={error.message} />}
                            </div>
                            <div className='flex flex-col w-[50%] mx-auto'>
                                {loading? <Loading isLoading={true} /> : <button type="submit" className=" mx-auto bg-gray-300 border shadow hover:text-white hover:bg-green-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-6 text-center duration-300 w-full">Editar Perfil</button>}
                            
                                <button type="button" className="mx-auto bg-gray-200 border shadow hover:text-white hover:bg-teal-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center duration-300 w-full" onClick={()=>setIsModalProfileUpdateOpen(false)}>Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default ModalProfileUpdate;